import './BaixarApp.css';
import imagem from "./img/BaixarApp.png";

function BaixarApp() {
  return (
    <div id="BaixarApp" className="BaixarAppContainer">
        <div className="BaixarAppLeft">
            <div className="BaixarAppTop">
                Baixe o app agora mesmo!
            </div>
            <div className="BaixarAppBottom">
                Venha fazer parte da empresa que está revolucionando a forma de ganhar renda extra!
            </div>
            <div className="BaixarAppButton" onClick={() => {window.location.href = "https://play.google.com/store/apps/details?id=com.sofie.sofier&hl=pt_BR&utm_source=lp-sofie&utm_campaign=video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"}}>
                <div className="BaixarAppButtonText">
                    CLIQUE AQUI
                </div>
            </div>
            {window.innerWidth > 800 &&
            <a href="https://play.google.com/store/apps/details?id=com.sofie.sofier&hl=pt_BR&utm_source=lp-sofie&utm_campaign=video&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                <img width="305px" alt="Disponível no Google Play" src="https://play.google.com/intl/pt-BR/badges/static/images/badges/pt_badge_web_generic.png" />
            </a>
            }
        </div>
        <div className="BaixarAppRight">
            <img src={imagem} width="100%" alt="Baixar App" />
        </div>
    </div>
  );
}

export default BaixarApp;
